const metaEl = document.querySelector('meta[name=token]')
const token = process.env.NODE_ENV === 'production' && metaEl ? metaEl.content : ''
export default {
  token,
  userInfo: {},
  routes: [], // 健康度路由配置
  allPermissions: [],
  /**
   * 有访问权限的url数组
   */
  permissions: [],
  /**
   * 有操作权限的prop数组
   */
  operateAuth: [],
  commonSelect: {},
  xunjianRoutes: [], // 巡检路由配置
  surveyRoutes: [], // 问卷调查项目管理路由配置 (project='survey')
  // 客户门户相关
  isCustomer: false, // 是否为客户账号
  customerProjectId: null // 客户关联的项目ID
}

